import Footer from './components/Footer';
import LandingNav from './components/LandingNav';
import { footerNavigation } from './contentSections';

export default function PrivacyPolicyPage() {
  return (
    <div className='bg-background text-foreground'>
      <LandingNav />
      <main className='mx-auto max-w-3xl px-6 py-32 lg:px-8'>
        <h1 className='text-4xl font-bold mb-2'>Privacy Policy</h1>
        <p className='text-sm text-muted-foreground mb-10'>Last updated: March 2026</p>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>1. Information We Collect</h2>
          <p className='text-muted-foreground leading-relaxed'>
            We collect information you provide when creating an account, registering an organization,
            or using the platform — including your name, email address, and organization details.
            We also collect usage data such as pages visited and features used to improve our service.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>2. How We Use Your Information</h2>
          <p className='text-muted-foreground leading-relaxed'>
            We use your information to operate and improve the platform, communicate with you about
            your account, and display your organization's public profile and posts to other community
            members. We do not sell your personal information to third parties.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>3. User-Generated Content</h2>
          <p className='text-muted-foreground leading-relaxed'>
            App is a community portal where users and organizations post content including
            announcements, events, listings, and other information. We do not endorse, verify, or
            take responsibility for any content posted by users or organizations on the platform.
            Users are solely responsible for the content they submit. If you encounter content that
            violates our guidelines, please contact us to report it.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>4. Cookies</h2>
          <p className='text-muted-foreground leading-relaxed'>
            We use cookies and similar technologies to maintain your session and remember your
            preferences. You can disable cookies in your browser settings, though some features
            may not function as expected.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>5. Data Security</h2>
          <p className='text-muted-foreground leading-relaxed'>
            We take reasonable measures to protect your personal information. However, no method of
            transmission over the internet is 100% secure and we cannot guarantee absolute security.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>6. Contact</h2>
          <p className='text-muted-foreground leading-relaxed'>
            If you have questions about this Privacy Policy, please contact us at{' '}
            <a href='/contact' className='text-primary hover:underline'>our contact page</a>.
          </p>
        </section>
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
}



